module.exports = __webpack_public_path__ + "img/caret-down.1b4743a1.svg";